<template>
  <div
    class="hero-background"
    @mousemove="handleMouseMove"
    @mouseleave="resetPosition"
    @click="scrollDownABit"
  >
    <div class="hero">
      <div class="banner" :style="backgroundStyle"></div>
      <div class="content">
        <div class="tom">
          <img src="tom.png" alt="" class="image-shadow" :style="shadowStyle" />
          <img src="tom.png" alt="" class="image" :style="profileStyle" />
        </div>
        <div class="text" :style="textStyle">
          <h1 class="title">Tom Mansion</h1>
          <p class="subtitle" v-if="subtitle">Full Stack Web Developer</p>
          <p class="description" v-if="description">
            Making stuff with my keyboard while I still feel like it<br />
            Welcome to my portfolio.
          </p>
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mouseX: 0,
      mouseY: 0,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        transform: `translate(${this.mouseX * -15}px, ${this.mouseY * -15}px)`,
      };
    },
    profileStyle() {
      return {
        transform: `translate(${this.mouseX * 15}px, ${this.mouseY * 15}px)`,
      };
    },
    shadowStyle() {
      return {
        transform: `scale(1.01)`,
      };
    },
    textStyle() {
      return {
        transform: `
         translateX(-15vh) skewY(-3deg) skewX(-3deg) translate(${
           this.mouseX * 10
         }px, ${this.mouseY * 10}px)`,
      };
    },
  },
  methods: {
    scrollDownABit() {
      window.scrollBy({ top: 300, behavior: "smooth" });
    },
    handleMouseMove(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      this.mouseX = (x - centerX) / centerX;
      this.mouseY = (y - centerY) / centerY;
    },
    resetPosition() {
      this.mouseX = 0;
      this.mouseY = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-background {
  position: relative;
  background: linear-gradient(135deg, #100013, #1b0015);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero {
  position: relative;
  padding: 6rem 1.5rem;
  height: 50vh;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .banner {
    position: absolute;
    inset: -15px;
    background: url("ban.png") center/cover no-repeat;
    transition: transform 0.3s ease-out;
    filter: blur(2px);
  }

  img {
    user-select: none;
    pointer-events: none;
  }

  .content {
    position: relative;
    z-index: 1;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 4rem;
  }

  .tom {
    .image-shadow {
      position: absolute;
      object-fit: contain;
      height: 70vh;
      transition: transform 0.3s ease-out;
      filter: blur(14px) brightness(0.5);
    }

    .image {
      object-fit: contain;
      transition: transform 0.3s ease-out;
      height: 70vh;
    }
  }

  .text {
    flex: 1;
    z-index: 1;
    user-select: none;
    pointer-events: none;
    transition: transform 0.3s ease-out;

    .title {
      margin-bottom: 0.5rem;
      color: white;
      font-size: calc(1.2vh + 1.5vw);
    }

    .subtitle {
      color: white;
      margin-bottom: 1rem;
      font-family: "consolas", monospace;
      font-style: italic;
      font-size: calc(0.5vh + 0.5vw);
    }

    .description {
      font-size: 1.1rem;
      color: white;
      font-size: calc(0.9vh + 0.9vw);
    }
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 3rem 1rem;

    .content {
      flex-direction: column;
      align-items: center;
      gap: 2rem;
    }

    .tom {
      .image-shadow,
      .image {
        height: 25vh;
      }
    }

    .text {
      text-align: center;
      transform: translateX(0) scale(1.5) skewY(-3deg) skewX(-3deg) !important;
    }
  }
}
</style>
